/* eslint-disable import/no-cycle */
import { Box } from '@chakra-ui/core';
import React from 'react';
import { FormFieldT } from '../../types';
import ElementPreview from './ElementPreview';
import SectionPreview from './SectionPreview';
import { getOptionIdForItem, isSectionSchema } from '../../utils';

export default function FollowUpPreview({
  optionId,
  schema,
  language,
  paddingLeft = 8,
}: {
  optionId: string;
  schema: FormFieldT;
  language: string;
  paddingLeft?: number;
}) {
  if (!schema?.followUpQuestionList?.length) return null;
  const followUps = schema?.followUpQuestionList?.filter((item) => item && getOptionIdForItem(item) === optionId);
  return (
    <Box paddingLeft={paddingLeft}>
      {followUps?.map((followUp) =>
        isSectionSchema(followUp) ? (
          <SectionPreview key={followUp.id} schema={followUp} language={language} />
        ) : (
          <ElementPreview key={followUp.id} schema={followUp} language={language} />
        ),
      )}
    </Box>
  );
}

FollowUpPreview.defaultProps = {
  paddingLeft: 8,
};
